export default "__VITE_ASSET__W0RjBhvl__"